import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import type { QueryKey } from '@tanstack/react-query'
import type { Address } from 'viem'

export function getPortfolioBalanceInvalidationKeys({
  account,
  chainId,
}: {
  account: Address
  chainId: number
}): QueryKey[] {
  return [
    ['readContract'],
    ['readContracts'],
    ['balance'],
    ['walletTokenBalances'],
    getBalancesQueryKeyPrefix({ account, chainId }),
  ]
}

export function getEulerPortfolioInvalidationKeys({
  account,
  chainId,
}: {
  account: Address
  chainId: number
}): QueryKey[] {
  return [
    ...getPortfolioBalanceInvalidationKeys({ account, chainId }),
    ['accountPositions'],
    ['eBorrowPositions'],
    ['evault'],
    ['elends'],
    ['eLendAccountData'],
    ['euler', 'evaults'],
  ]
}
